var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5892 1.07733L18.9225 4.41066C19.2479 4.7361 19.2479 5.26374 18.9225 5.58917L10.5892 13.9225C10.4329 14.0788 10.2209 14.1666 9.99992 14.1666H6.66658C6.20635 14.1666 5.83325 13.7935 5.83325 13.3333V9.99992C5.83325 9.7789 5.92105 9.56694 6.07733 9.41066L14.4107 1.07733C14.7361 0.751893 15.2637 0.751893 15.5892 1.07733ZM7.49992 10.3451V12.4999H9.65474L17.1547 4.99992L14.9999 2.8451L7.49992 10.3451ZM16.6666 11.3833C16.2063 11.3833 15.8333 11.7563 15.8333 12.2166V16.6666C15.8333 17.1268 15.4602 17.4999 14.9999 17.4999H3.33325C2.87301 17.4999 2.49992 17.1268 2.49992 16.6666V4.99992C2.49992 4.53968 2.87301 4.16659 3.33325 4.16659H7.78325C8.24349 4.16659 8.61659 3.79349 8.61659 3.33325C8.61659 2.87301 8.24349 2.49992 7.78325 2.49992H3.33325C1.95254 2.49992 0.833252 3.61921 0.833252 4.99992V16.6666C0.833252 18.0473 1.95254 19.1666 3.33325 19.1666H14.9999C16.3806 19.1666 17.4999 18.0473 17.4999 16.6666V12.2166C17.4999 11.7563 17.1268 11.3833 16.6666 11.3833Z",
    fill: "#171414"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.180e8c2dd482f466320c1726661b98e7.svg";
export { ForwardRef as ReactComponent };